'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function getEventTarget(event) {
  return event.composedPath?.()[0] ?? event.target;
}

exports.getEventTarget = getEventTarget;
